export const Task = {

    list_legacy: function () {
        var pageLen;
        if (window.location.hash.substr(1).length > 0){
          pageLen = 5000;
        } else {
          pageLen = 50;
        }
        this.table = jQuery('table.tasks');
        this.table.dataTable({
            serverSide: true,
            ajax: this.table.attr('data-url'),
            info: true,
            lengthChange: false,
            language: {
              searchPlaceholder: I18n.t('search')
            },
            pageLength: pageLen,
            autoWidth: false,
            stateSave: true,
            processing: true,
            sorting: [[DataTablesHelper.colIndex(this.table, 'created_at'), 'desc']],
            rowId: '0.id',
            columnDefs: [
                {
                    render: function (data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#task-identifier-template').html().
                                replace(/__id__/g, encodeURIComponent(data.id)).
                                replace(/__label__/g, data.label).
                                replace(/__title__/g, data.title);
                        }
                        return data.label;
                    },
                    targets: DataTablesHelper.colIndex(this.table, 'identifier')
                },
                {
                    render: function (data, type, row, meta) {
                        if (type == 'display' && data.id) {
                            return jQuery('#task-target-project-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__project_identifier__/g, data.project_identifier);
                        }
                        return data.project_identifier || '';
                    },
                    targets: DataTablesHelper.colIndex(this.table, 'project_identifier')
                },
                {
                    render: function (data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#task-status-template').html().
                                replace(/__status__/g, data.status).
                                replace(/__label__/g, data.label);
                        }
                        return data.status;
                    },
                    targets: DataTablesHelper.colIndex(this.table, 'status')
                },
                {
                    orderable: false,
                    targets: DataTablesHelper.colIndex(this.table, 'actions')
                },
                {
                  render: function(data,type,row,meta) {
                    if (type == 'display') {
                      if (data.assignee){
                        return data.assignee
                      } else {
                        return '-';
                      }
                    }
                    return data.assignee;
                  },
                  orderable: false,
                  targets: DataTablesHelper.colIndex(this.table, 'assignee')
                },
                {
                  render: function(data,type,row,meta) {
                    if (type == 'display') {
                      return data.label;
                    }
                    return data.sort;
                  },
                  targets: DataTablesHelper.colIndex(this.table, 'created_at')
                }
                // {
                //     orderable: false,
                //     render: function (data, type, row, meta) {
                //         if (type == 'display') {
                //             return jQuery('#report-actions-template').html().
                //                 replace(/__id__/g, data.id).
                //                 replace(/__label__/g, data.label);
                //         }
                //         return '';
                //     },
                //     targets: [2]
                // }
            ],
            drawCallback: function () {
                DataTablesHelper.addColumnFilters(this);
            },
            footerCallback: function () {
                DataTablesHelper.togglePagination(this);
            },
            "stateSaveParams": function(settings, data) {
              delete data.length
            },
            "initComplete": function() {
              // Jump to #id set in url
              var hash = window.location.hash.substr(1)
              if (hash.length > 0) {
                if ($('#' + hash).offset() != undefined) {
                  $('html, body').animate({
                    scrollTop: $('#' + hash).offset().top - 110
                  }, 500);
                  $('#' + hash).addClass('task-highlight')
                }
              }
            }
        });

        // table.on('click', 'a.delete-report', function () {
        //     var a = jQuery(this);

        //     if (confirm(a.attr('data-confirm'))) {
        //         jQuery.post(a.attr('href'), function () {
        //             Turbo.visit(window.location.href);
        //         });
        //         a.hide();
        //     }
        //     return false;
        // });
    },


    _show: function() {
        // Format description
        var desc = jQuery('.task-description');
        desc.html(Autolinker.link(StringHelper.simpleFormat(desc.text()), {
            stripPrefix: { scheme: false, www: false }
        }));

        // Change status
        ActionJS.Task._initStatusChange();
        ActionJS.Task._assign(true);
    },

    _new: function() {
      jQuery('.select2').select2();

      jQuery('.select-none').on('click', function(){
        $(this).closest('.form-group').find('.select2').val(null).trigger('change');
      })

      jQuery('.select-all').on('click', function(){
        var allValues = $(this).closest('.form-group').find('.select2 option').map(function(i,v){ return v.value}).toArray()
        $(this).closest('.form-group').find('.select2').val(allValues).trigger('change');
      })

      jQuery('.select-group').on('click', function(){
        var values = $(this).closest('.form-group').find('.select2 optgroup[label="' + $(this).data('opt-group') + '"] option').map(function(i,v){ return v.value}).toArray()
        $(this).closest('.form-group').find('.select2').val(values).trigger('change');
      })
    },

    _initStatusChange: function() {
      jQuery('a.update-status').on('click', function() {
        jQuery(this).closest('.dropdown-menu').hide();
        var container = jQuery(this).closest('.dropdown')
        jQuery.post(this.getAttribute('href'), function (res) {
          container.replaceWith(res);
          ActionJS.Task._initStatusChange();
          if (ActionJS.Task.table) {
            ActionJS.Task.table.api().ajax.reload();
          }
          jQuery('#task-datagrid-reload-button').trigger('click')
        });
        return false;
      });
    },

    _assign: function(reload){
      jQuery('.task-assignee-container a').on('click', function(e){
        e.preventDefault();

        var container = jQuery(this).closest('.task-assignee-container')

        container.find('.task-assignee-view').addClass('hidden');
        container.find('.task-assignee-edit').removeClass('hidden');
        container.find('.task-assignee-edit').html(SmartME.loadingIndicator(20));

        container.find('.task-assignee-edit').load(jQuery(this).attr('href'), function(){
          container.find('.task-assignee-edit').find('.loading-indicator').remove();

          jQuery('.task-assignee-edit button').on('click', function(e){
            if (reload) {
              SmartME.setLoadingIndicator('.main', { overlay: true });
            }

            e.preventDefault();
            e.stopPropagation();
            var value = jQuery('.task-assignee-edit select').val();

            jQuery(this).attr('disabled', true);

            jQuery.post(
              container.find('.task-assignee-edit').attr('data-action').replace('__person_id__', value), 
              function(res){
                if (reload) {
                  Turbo.visit(window.location.href);
                } 
                container.find('.task-assignee-edit').empty();
                container.find('.task-assignee-view .task-assignee').text(res);
                container.find('.task-assignee-view').removeClass('hidden');
              }
            );
          });
        });

        return false;
      });
    },

    _edit_assignee: function(){
      $('select.select2').select2();

      jQuery('.cancel-assignee-btn').on('click', function(e){
        var container = jQuery(this).closest('.task-assignee-container');
        container.find('.task-assignee-edit').addClass('hidden');
        container.find('.task-assignee-view').removeClass('hidden');
      })
    }
}